module.exports = __webpack_public_path__ + "assets/e3cfec390ab41bdffa9f960870ccaec5.png";